import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { PROMO_CARD_SHADOW } from './constants';
export const CardStyled = styled.div `
  padding: ${INDENT.sm};
  box-shadow: ${PROMO_CARD_SHADOW};
  background: ${colorCoreWhite1000};
`;
